// src/components/Projects/ProjectCard.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function ProjectCard({ project, layout = "home" }) {
  const { t, i18n } = useTranslation("projectsTranslation");

  const baseKey = project?.i18nKey ? `projects.${project.i18nKey}` : null;

  const title = baseKey
    ? t(`${baseKey}.card.title`, { defaultValue: project?.title || "" })
    : project?.title || "";

  const badge = baseKey
    ? t(`${baseKey}.card.badge`, { defaultValue: project?.shortTitle || "" })
    : project?.shortTitle || "";

  const summary = baseKey
    ? t(`${baseKey}.card.summary`, { defaultValue: project?.summary || "" })
    : project?.summary || "";

  const coordinator = baseKey
    ? t(`${baseKey}.card.coordinator`, {
        defaultValue: project?.coordinator || "",
      })
    : project?.coordinator || "";

  const duration = baseKey
    ? t(`${baseKey}.card.duration`, {
        startDate: project?.startDate,
        endDate: project?.endDate,
        months: project?.durationMonths,
        defaultValue: project?.duration || "",
      })
    : project?.duration || "";

  const countries = baseKey
    ? t(`${baseKey}.card.countries`, {
        universities: project?.universitiesCount,
        countries: project?.countriesCount,
        defaultValue: project?.countries || "",
      })
    : project?.countries || "";

  const moreDetailsLabel = t("ui.moreDetails", {
    defaultValue: i18n.language === "en" ? "More details" : "Više detalja",
  });

  return (
    <div className={`project-card project-card--${layout}`}>
      {/* COVER */}
      {project?.coverImage && (
        <div className="project-card-cover">
          <img src={project.coverImage} alt={title || "Project cover"} />
        </div>
      )}

      {/* BODY */}
      <div className="project-card-body">
        {badge && <span className="project-card-badge">{badge}</span>}

        <h3 className="project-card-title">{title}</h3>

        {summary && <p className="project-card-summary">{summary}</p>}

        {/* META */}
        <ul className="project-card-meta">
          {duration && (
            <li>
              <i className="fa fa-calendar" aria-hidden="true"></i>
              <span>{duration}</span>
            </li>
          )}
          {countries && (
            <li>
              <i className="fa fa-globe" aria-hidden="true"></i>
              <span>{countries}</span>
            </li>
          )}
          {coordinator && (
            <li>
              <i className="fa fa-university" aria-hidden="true"></i>
              <span>{coordinator}</span>
            </li>
          )}
        </ul>
      </div>

      {/* TAGS (poseban red) */}
      {Array.isArray(project?.tags) && project.tags.length > 0 && (
        <div className="project-card-tags">
          {project.tags.map((tag) => (
            <span key={tag} className="project-card-tag">
              {tag}
            </span>
          ))}
        </div>
      )}

      {/* FOOTER (samo dugme, desno) */}
      <div className="project-card-footer">
        <Link to={project.link} className="btn btn-sm project-card-btn">
          {moreDetailsLabel}
        </Link>
      </div>
    </div>
  );
}

export default ProjectCard;
